// extracted by mini-css-extract-plugin
export var box = "_5s-0";
export var check = "_5s-1";
export var checkboxButton = "_5s-6";
export var checkboxGroup = "_5s-5";
export var disabled = "_5s-7";
export var ghost = "_5s-9";
export var input = "_5s-2";
export var label = "_5s-4";
export var normal = "_5s-8";
export var uncheck = "_5s-3";